import { useQuery } from "@tanstack/react-query";
import { fetchLpMarkout, type MandateParams } from "../api/client.ts";

// DEX-only, term-structure read over a 30d window. Calm poll like the other
// mandate cards; keyed on the market, refetches on binding change.
const POLL_MS = 30_000;

export function useLpMarkout(p: MandateParams) {
  return useQuery({
    queryKey: ["lp-markout", p.clientId, p.venue, p.pair],
    queryFn: () => fetchLpMarkout(p),
    refetchInterval: POLL_MS,
    staleTime: POLL_MS,
  });
}
